import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ListFields } from '../../listfields';

@Component({
  selector: 'app-search-badge',
  templateUrl: './search-badge.component.html',
  styleUrl: './search-badge.component.scss',
  standalone: false
})
export class SearchBadgeComponent {

  @Input() searchByList: any = {};
  @Input() listFields: ListFields[] = [];
  @Output() searchByListChange = new EventEmitter();

  constructor() {
  }

  public clearElement(searchKey: any) {
    delete this.searchByList[searchKey];
    this.searchByListChange.emit({...this.searchByList});
  }

  public getSearchFieldDisplayName(fieldName: any): string {
    return this.listFields.find((listFieldEl) => { return listFieldEl.FieldName == fieldName })?.DisplayName!;
  }
}
